const { NODE_ENV } = process.env;
const isProduction = NODE_ENV === 'production';

const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(isProduction ? '/static/sw.js' : '/sw.js', {
      scope: isProduction ? '/static/' : '/',
    });
  }
};

const attachServiceWorker = () => {
  window.addEventListener('load', registerServiceWorker);
};

export { attachServiceWorker };
